import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  public getLanguage() {
    return window.location.pathname.split('/')[1] ?? '';
  }

  public setLanguage(language: string) {
    const path = window.location.pathname.substring(this.getLanguage().length + 1);
    window.location.href = `${window.location.origin}/${language}${path}`;
  }
}
